// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".g7cdugaTVX6mlSK72xEs {\n  margin-top: 36px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/shop/ShoppingWizard/StepButtons/StepButtons.module.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF","sourcesContent":[".container {\n  margin-top: 36px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "g7cdugaTVX6mlSK72xEs"
};
export default ___CSS_LOADER_EXPORT___;
